import { Button } from "@progress/kendo-react-buttons";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AgentIcon from "@/components/AILanding/icons/Agent.svg?react";
import { useSlidePanelMounted } from "@/components/slide-panel";
import { hasBlockingOverlay } from "@/helpers/focus";
import { useGuardian } from "./GuardianProvider";
import GuardianRail from "./GuardianRail";
import "./guardian-rail.scss";

const GuardianSurface: React.FC = () => {
  const { t } = useTranslation();
  const guardian = useGuardian();
  const hidden = guardian.isHidden;
  const mounted = useSlidePanelMounted(guardian.isOpen);
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    const update = () => setBlocked(hasBlockingOverlay());
    update();
    // Both blocking surfaces arrive as direct children of `body`: Kendo
    // portals its dialogs there, and `ReactPortal` appends (and ref-counts)
    // the `slide-panel-portal` wrapper there. So `subtree` is not needed —
    // without it this fires on a handful of portal mounts instead of after
    // every commit in the app. Changes *inside* an existing wrapper cannot
    // flip the answer: the wrapper only exists while a panel is mounted.
    let frame = 0;
    const observer = new MutationObserver(() => {
      frame ||= requestAnimationFrame(() => {
        frame = 0;
        update();
      });
    });
    observer.observe(document.body, { childList: true });
    return () => {
      if (frame) cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, []);
  // Keep a mounted transcript intact on the dedicated chat page.
  return (
    <div hidden={hidden} inert={blocked || hidden || undefined}>
      {!guardian.isOpen && (
        <Button
          type="button"
          themeColor="primary"
          className="tlx-guardian-launcher"
          aria-label={t("trustAiBoard.guardian.open")}
          title={t("trustAiBoard.guardian.open")}
          onClick={guardian.open}
          data-test-id="guardian-launcher"
        >
          <AgentIcon aria-hidden="true" focusable="false" />
        </Button>
      )}
      {mounted && (
        <GuardianRail open={guardian.isOpen} isBlocked={blocked || hidden} />
      )}
    </div>
  );
};
export default GuardianSurface;
